export default __webpack_public_path__ + "static/media/e-bunifikasi-logotype-d.9a74b5a6.svg";